/* import React from "react";
import { FaCut } from "react-icons/fa";
import { FiLogIn } from "react-icons/fi";
import { Link } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  return (
    <nav className="navbar">
      <Link to="/" className="nav-icon">
        <FaCut />
      </Link>

      <h1 className="nav-title">Barberian</h1>

      <Link to="/login" className="nav-icon">
        <FiLogIn />
      </Link>
    </nav>
  );
}
 */

import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth"; // Importaj useAuth hook
import "./Navbar.css";

export default function Navbar({
  leftIcon: LeftIcon,
  leftLink,
  rightIcon: RightIcon,
  rightLink,
  isLogout,
}) {
  const { logout } = useAuth();

  return (
    <nav className="navbar">
      <Link to={leftLink || "/"} className="nav-icon">
        {LeftIcon && <LeftIcon />}
      </Link>

      <h1 className="nav-title">Barberian</h1>

      {isLogout ? (
        <button className="nav-icon logout-btn" onClick={logout}>
          {RightIcon && <RightIcon />}
        </button>
      ) : (
        <Link to={rightLink || "/"} className="nav-icon">
          {RightIcon && <RightIcon />}
        </Link>
      )}
    </nav>
  );
}
